<template>
    <div
        v-if="(isProjectPath && !dataLoading) || visible"
        :class="{
            inlineBlock: inSnackbar,
        }"
    >
        <div class="loading-inline-row">
            <span
                v-if="
                    project &&
                        project.lastUpdate &&
                        GCB2Inited &&
                        !hideTimestamp &&
                        !inSnackbar &&
                        showUpdated
                "
                class="date-text"
            >
                {{ `Обновлено: ${new Date(project.lastUpdate).toLocaleString()} ` }}
            </span>
            <v-tooltip bottom v-if="spinnerStatus !== null">
                <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" v-if="checkRole(project.id, 'project:communicationUpdate')">
                        <div
                            class="updateButton custom-highlight"
                            @click="updateProject"
                            id="reloadBtn"
                            :class="{
                                white: inSnackbar,
                                isError: color === 'error',
                                'topbar-solid-bg': topbarSolidBackground,
                            }"
                        >
                            <div class="updateButton__before">
                                <v-btn
                                    v-if="
                                        spinnerStatus === 'idleError' ||
                                            (color === 'error' && spinnerStatus !== 'loading')
                                    "
                                    icon
                                    small
                                    ><v-icon size="18px" color="error">mdi-sync</v-icon></v-btn
                                >

                                <v-btn v-else-if="spinnerStatus === 'idle'" icon small
                                    ><v-icon size="18px" color="mainNew">mdi-sync</v-icon></v-btn
                                >
                            </div>

                            <v-progress-circular
                                :style="{
                                    margin: '0 auto;',
                                }"
                                indeterminate
                                :color="color === 'error' ? 'error' : 'mainNew'"
                                size="16"
                                width="2"
                                class="progressBar"
                                v-if="spinnerStatus === 'loading'"
                            ></v-progress-circular>

                            <v-btn v-if="spinnerStatus === 'success'" icon small
                                ><v-icon size="18px" color="success">mdi-check-circle</v-icon></v-btn
                            >
                            <v-btn size="18px" v-if="spinnerStatus === 'error'" icon small
                                ><v-icon color="error">mdi-alert-circle</v-icon></v-btn
                            >

                            <div class="updateButton__text">{{ updateButtonText }}</div>
                        </div>
                    </div>
                </template>
                <span class="white--text">{{ tooltipText }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import { communicationUpdate } from '@root/src/api/chisai/GCB2'
import { checkRole } from '@/helpers/roles'

const spinnerStatuses = {
    idle: 'idle',
    idleError: 'idleError',
    loading: 'loading',
    success: 'success',
    error: 'error',
}
const CHANGE_SPIINER_STATUS_TIMEOUT = 3 // в секундах
export default {
    name: 'Loading',
    components: {},
    data: () => ({
        dataLoading: true,
        prevSpinnerStatus: null,
        spinnerStatus: null,
        loadingStatus: false,
        loadingValue: 0,
        loadingInterval: null,
    }),
    props: {
        isProjectPath: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        inSnackbar: {
            type: Boolean,
            default: false,
        },
        showUpdated: {
            type: Boolean,
            default: true,
        },
        color: {
            type: String,
            default: 'main',
        },
        topbarSolidBackground: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        project() {
            const projectId = this.$route.params.id
            return this.$store.getters.projectById(projectId)
        },
        // loadingCommunicationUpdate обновляется в сторе по realtime-событию (helpers/projectRealtime).
        // Строка, а не объект: вотчер на объект срабатывает при любой замене проекта в сторе,
        // а спиннеру нужны только реальные изменения статуса.
        communicationLoadingKey() {
            if (!this.project) {
                return null
            }
            return JSON.stringify([this.project.id, this.project.loadingCommunicationUpdate ?? null])
        },
        excludedStages() {
            return this.project?.settings?.loading?.updateExcludedStages
        },
        startLoadingTime() {
            return this.$store.state.project.startLoadingTime
        },
        tooltipText() {
            let text = null
            //выбираем текст тултипа в зависимости от статуса спиннера
            switch (this.spinnerStatus) {
                case spinnerStatuses.idle:
                    text = 'Обновить'
                    break
                case spinnerStatuses.loading:
                    text = 'Загрузка...'
                    break
                case spinnerStatuses.success:
                    text = 'Процесс обновления завершен!'
                    break
                case spinnerStatuses.error:
                    text = 'Ошибка!'
                    break
                case spinnerStatuses.idleError:
                    text = 'Последняя попытка обновления произошла с ошибкой. \nОбновить еще раз?'
                    break
                default:
                    break
            }
            return text
        },
        updateButtonText() {
            switch (this.spinnerStatus) {
                case spinnerStatuses.loading:
                    return 'Обновление расчетов'
                case spinnerStatuses.success:
                    return 'Расчеты обновлены'
                case spinnerStatuses.error:
                    return 'Ошибка обновления'
                default:
                    return 'Обновить расчеты'
            }
        },
        hideLoading() {
            return this.project?.settings?.loading?.hideLoading
        },
        hideTimestamp() {
            return this.project?.settings?.loading?.hideTimestamp
        },
        GCB2Inited() {
            return this.project?.initChisai?.GCB2
        },
    },
    watch: {
        //Следим за изменением страницы проекта
        '$route.params.id': {
            immediate: true,
            async handler(newRouteProjectId, _oldRouteProjectId) {
                this.prevSpinnerStatus = null
                this.spinnerStatus = null
                this.errors = null
                if (newRouteProjectId) {
                    this.$nextTick(() => this._syncSpinnerFromProject())
                }
            },
        },
        // Должен идти после '$route.params.id': при смене проекта сначала сброс, потом новый статус
        communicationLoadingKey: {
            immediate: true,
            handler(key) {
                if (key === null) {
                    return
                }
                this._applyCommunicationLoading(this.project.loadingCommunicationUpdate)
            },
        },
        isProjectPath: {
            handler(isProjectPath) {
                if (isProjectPath) {
                    this.$nextTick(() => this._syncSpinnerFromProject())
                }
            },
        },
        project: {
            immediate: true,
            handler() {
                // После смены пользователя/перемонтирования шапки вотчер project может отработать раньше,
                // чем $route.params.id обнулит спиннер; тогда idle затирается в null и кнопка не появляется.
                // nextTick гарантирует применение состояния после сброса маршрута в том же тике.
                this.$nextTick(() => this._syncSpinnerFromProject())
            },
            // Не подписываемся на изменения проекта, чтобы избежать бесконечного цикла
            deep: false,
        },
        spinnerStatus() {
            switch (this.spinnerStatus) {
                case spinnerStatuses.idle:
                    this.$store.commit('setCommunicationUpdate', false)
                    break
                case spinnerStatuses.loading:
                    this.$store.commit('setCommunicationUpdate', true)
                    break
                case spinnerStatuses.success:
                    this.$store.commit('setCommunicationUpdate', false)
                    break
                case spinnerStatuses.error:
                    this.$store.commit('setCommunicationUpdate', false)
                    break
                case spinnerStatuses.idleError:
                    this.$store.commit('setCommunicationUpdate', false)
                    break
                default:
                    this.$store.commit('setCommunicationUpdate', false)
                    break
            }
        },
        '$store.state.isCommunicationUpdate': {
            handler(isLoading) {
                const canSyncSpinner =
                    (this.inSnackbar && this.visible) ||
                    (this.isProjectPath && this.spinnerStatus !== null)

                if (!canSyncSpinner) {
                    return
                }

                if (isLoading && this.spinnerStatus !== spinnerStatuses.loading) {
                    this.prevSpinnerStatus = this.spinnerStatus
                    this.spinnerStatus = spinnerStatuses.loading
                } else if (!isLoading && this.spinnerStatus === spinnerStatuses.loading) {
                    // Не меняем статус сразу, ждем события от websocket для правильного перехода в success
                }
            },
            immediate: false,
        },
    },
    methods: {
        checkRole,
        _applyCommunicationLoading(loading) {
            this.dataLoading = true
            const loadingValue = loading || { status: false, isError: false }
            this.setSpinnerStatusAndLastLoadingTime(loadingValue)
            this.setErrors(loadingValue)
            this.dataLoading = false
            if (this.spinnerStatus === null) {
                this.$nextTick(() => this._syncSpinnerFromProject())
            }
        },
        _syncSpinnerFromProject() {
            const shouldShow = this.isProjectPath || this.visible
            if (!shouldShow) {
                return
            }

            const newProject = this.project
            if (!newProject) {
                return
            }

            if (this.spinnerStatus !== null) {
                this.dataLoading = false
                return
            }

            if (!newProject.connectors || newProject.connectors.every(connector => connector.isDraft)) {
                this.dataLoading = false
                return
            }

            if (this.hideLoading) {
                this.dataLoading = false
                return
            }

            this.spinnerStatus = spinnerStatuses.idle
            this.prevSpinnerStatus = spinnerStatuses.idle
            this.dataLoading = false
        },
        setSpinnerStatusAndLastLoadingTime(loading) {
            //Если у всех коннекторов не завершено подключение, не показываем значек загрузки
            if (!this.project || this.project.connectors.every(connector => connector.isDraft)) {
                this.$nextTick(() => this._syncSpinnerFromProject())
                return
            }
            if (!loading) {
                return
            }
            //Не показывать значек загрузки, если в настройках это указано
            if (this.hideLoading) {
                this.spinnerStatus = null
                return
            }
            if (this.prevSpinnerStatus === spinnerStatuses.loading && loading.status === false) {
                //выбираем какой должен быть значек загрузки
                this.spinnerStatus = spinnerStatuses.success
                this.prevSpinnerStatus = spinnerStatuses.success
                setTimeout(() => {
                    this.spinnerStatus = spinnerStatuses.idle
                    this.prevSpinnerStatus = spinnerStatuses.idle
                }, CHANGE_SPIINER_STATUS_TIMEOUT * 1000)
                const projectId = this.$router.currentRoute.params.id
                //Если проект загрузился, грузим обновленный проект чтобы получить дату последней загрузки
                if (projectId) {
                    this.$store.dispatch('project/fetchProject', projectId)
                }
            } else if (loading.status === false) {
                this.spinnerStatus = spinnerStatuses.idle
                this.prevSpinnerStatus = spinnerStatuses.idle
            } else if (loading.status === true) {
                this.spinnerStatus = spinnerStatuses.loading
                this.prevSpinnerStatus = spinnerStatuses.loading
            }
        },
        setErrors(loading) {
            if (!loading) {
                return
            }
            this.errors = loading.errors
                ? loading.errors.reduce((acc, cur) => acc + cur.error + '\n', '\n')
                : null
        },
        finishTour() {
            if (this.$tours.btnHighlight) {
                // @ts-ignore
                this.$tours.btnHighlight?.stop()
            }
        },
        async updateProject() {
            this.finishTour()
            // Сразу устанавливаем состояние в store для синхронизации всех спиннеров
            this.$store.commit('setCommunicationUpdate', true)
            this.prevSpinnerStatus = spinnerStatuses.loading
            this.spinnerStatus = spinnerStatuses.loading
            await communicationUpdate({ projectId: this.project.id })
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/vars.sass';

.loading-inline-row {
    display: inline-flex;
    align-items: center;
}

.date-text {
    font-size: 12px;
    color: rgba(255, 255, 255, .56);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    line-height: 1;
}

.hidden {
    visibility: hidden;
}

.progressBar {
    margin: 0 8px 0 6px;
}

.inlineBlock {
    display: inline-block;
    margin-left: 12px;
}

.updateButton {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    height: 36px;
    padding: 0 14px 0 10px;
    font-size: 12.5px;
    font-weight: 800;
    letter-spacing: -.01em;
    background: rgba(255, 255, 255, .05);
    border: 1px solid rgba(255, 255, 255, .17);
    border-radius: 10px;
    cursor: pointer;
    transition: transform .15s ease, background .15s ease, border-color .15s ease;

    .updateButton__before {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 2px;
    }
    
    ::v-deep .v-btn {
        min-width: 20px !important;
        width: 20px !important;
        height: 20px !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    ::v-deep .v-icon {
        color: rgba(255, 255, 255, .72) !important;
    }

    &.isError ::v-deep .v-icon {
        color: #e20029 !important;
    }

    &.isError {
        border: 1px solid #e20029;

        .updateButton__text {
            color: #e20029 !important;
        }
    }

    &__text {
        color: rgba(255, 255, 255, .94);
        // text-transform: uppercase;
    }

    &:hover {
        transform: translateY(-1px);
        background: rgba(255, 255, 255, .085);
        border-color: rgba(255, 255, 255, .26);
    }

    &:active {
        transform: translateY(0);
        background: rgba(255, 255, 255, .11);
    }

    &.white {
        border: 1px solid #fff;
        display: inline-flex;
        align-items: center;
        flex-wrap: nowrap;
        white-space: nowrap;

        .updateButton__text {
            color: $main-new !important;
        }

        ::v-deep .v-icon {
            color: $main-new !important;
        }
    }

    &.topbar-solid-bg {
        background: #1a1a2e;
        border-color: rgba(255, 255, 255, .24);
    }

    &.topbar-solid-bg:hover {
        background: #202239;
        border-color: rgba(255, 255, 255, .32);
    }
}

@media (max-width: 1180px) {
    .date-text {
        display: none;
    }
}

@media (max-width: 760px) {
    .updateButton {
        width: 34px;
        min-width: 34px;
        height: 34px;
        padding: 0;
        border-radius: 9px;
    }

    .updateButton__before {
        margin-right: 0 !important;
    }

    .updateButton__text {
        display: none;
    }

    .progressBar {
        margin: 0 auto;
    }
}
</style>
